<template>
  <table class="table border table-striped table-hover mt-2">
    <thead>
      <tr>
        <th scope="col" style="cursor: pointer;" @click="sortClients('FIRSTNAME')">
          <span>Name</span>
          <span>&nbsp;<font-awesome-icon icon="sort" class="m-0"/></span>
        </th>
        <th scope="col" style="cursor: pointer;" @click="sortClients('LASTNAME')">
          <span>Lastname</span>
          <span>&nbsp; <font-awesome-icon icon="sort" class="m-0" /> </span>
        </th>
        <th scope="col" style="cursor: pointer;" @click="sortClients('USERNAME')">
          <span>Username</span>
          <span>&nbsp;<font-awesome-icon icon="sort" class="m-0"/></span>
        </th>
        <th scope="col" style="cursor: pointer;" @click="sortClients('COMPANY')">
          <span>Business Unit</span>
          <span>&nbsp;<font-awesome-icon icon="sort" class="m-0"/></span>
        </th>
        <th scope="col" style="cursor: pointer;" @click="sortClients('LOCKED')">
          <span>Locked</span>
          <span>&nbsp;<font-awesome-icon icon="sort" class="m-0"/></span>
        </th>
        <th scope="col"></th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="client in clientUserResults" :key="client.id">
        <td scope="col">{{ client.first_name }}</td>
        <td scope="col">{{ client.last_name }}</td>
        <td scope="col">{{ client.user_name }}</td>
        <td scope="col">{{ client.company }}</td>
        <td scope="col">
          <font-awesome-icon icon="lock" style="color: black;" class="ml-2" v-if="client.locked" />
          <font-awesome-icon icon="lock-open" style="color: black;" class="ml-2" v-if="!client.locked" />
        </td>
        <td scope="col">
          <router-link
            class="btn btn-primary btn-sm"
            :to="{
              name: 'AdminSettingsRoleAndPermissionsAssignRoles',
              query: {
                Id: client.id,
                company_id: client.company_id,
                user_name: encodeURI(client.user_name),
              },
              params: {
                first_name: client.first_name,
                last_name: client.last_name,
                customer_id: client.customer_id,
              },
            }"
            >Assign Roles</router-link
          >
        </td>
      </tr>
      <tr v-if="!clientUserResults">
        <td colspan="6" class="text-center">No Users Found.</td>
      </tr>
    </tbody>
  </table>
</template>

<script>
export default {
  name: 'ManageUserRolesTable',
  props: {
    sortClients: {
      type: Function,
      required: true,
    },
  },
  computed: {
    clientUserResults() {
      return this.$store.state.settings.clientUsersData.Result;
    },
  },
};
</script>

<style></style>
